<template>
  <div class="home">
    <slot name="breadcrumbsWrp" ></slot>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

